"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import React from 'react';

const LevelKeysConflictContext = React.createContext(/* @__PURE__ */ new Set());
const useLevelKeysConflicts = () => React.useContext(LevelKeysConflictContext);

export { LevelKeysConflictContext, useLevelKeysConflicts };
